/** Fase 2 (W33, item 5.6): subtítulos de página en español (ver `subtitulos-pt.ts`). */
export const subtitulosEs = {
  inicio: 'Visión general del negocio en el período elegido',
  automacoes: 'Robots y rutinas automáticas de la operación, en un solo lugar',
  externo: 'Sistema externo abierto dentro de MalgoOS; el inicio de sesión y los datos siguen en él',
  subsistemas: 'Elige la empresa y el subsistema; el menú muestra solo lo que es de él',
  notificacoes: 'Sigue todas las notificaciones del sistema y elige cómo recibir cada una',
  conta: {
    perfil: 'Administra tu información personal y consulta tus accesos',
    aparencia: 'Elige tema, color de acento, fuente y tamaño del texto solo para ti',
    seguranca: 'Contraseña, verificación en dos pasos, passkeys y sesiones abiertas',
    assistentes: 'Tus asistentes de IA, lo que prepararon y el uso en el período',
    lixeira: 'Lo que eliminaste en los últimos 30 días, con la opción de deshacer',
    'meus-dados': 'Tu ficha de empleado: datos personales, contrato, salario, documentos e historial',
  },
  paginas: {
    cadastros: {
      pessoas: 'Clientes, proveedores y socios unificados: una persona puede tener varios roles',
      projetos: 'Proyectos de los clientes, para agrupar contratos, tareas y movimientos',
      classificacao: 'Etiquetas y sectores para clasificar y filtrar los registros',
      servicos: 'Administra los servicios ofrecidos a los clientes',
      'servicos-contratados': 'Servicios que tu empresa contrata a terceros (contador, limpieza, TI...)',
      'condicoes-pagamento': 'Plazos y cuotas usados en ventas, compras y documentos',
      'formas-pagamento': 'Administra las formas de pago que acepta la empresa',
    },
    financeiro: {
      'centros-custo': 'Administra los centros de costo',
      contas: 'Administra las cuentas financieras de la empresa (bancos y caja)',
      categorias: 'Estructura contable de la empresa',
      'entradas-saidas': 'Todo el dinero que entró y salió de tus cuentas',
      conciliacao: 'Compara con el banco (conciliación) lo que entró y salió de tus cuentas',
      'fluxo-caixa': 'Entradas y salidas por período, realizadas y previstas',
      indices: 'Índices de reajuste (IPCA, IGP-M y otros) usados en los contratos',
    },
    contas: {
      'a-receber': 'Cuentas que tus clientes van a pagar',
      'a-pagar': 'Cuentas que vas a pagar',
      cobrancas: 'Recordatorios de cobro: avisos a los clientes antes y después del vencimiento',
      recorrencias: 'Mensualidades y cuentas fijas emitidas solas en cada ciclo',
      'notas-credito': 'Notas de crédito emitidas a los clientes, que reducen el monto por cobrar',
    },
    relatorios: {
      inicio: 'Análisis financieros y operativos',
      'painel-grupo': 'Ingresos, gastos, saldos, contratos y personas de cada empresa del grupo y el total',
      inadimplencia: 'Documentos vencidos por rango de días',
      dre: 'Estado de resultados del ejercicio',
      fluxo: 'Entradas y salidas por período, realizado o previsto, hasta el movimiento',
      extrato: 'Entradas y salidas (por cobrar y por pagar) con saldo acumulado',
      centros: 'Ingresos y gastos de cada centro de costo',
      parceiros: 'Ingresos por cliente y gastos por proveedor, ordenados por monto',
      mrr: 'Ingreso recurrente mensual de los contratos activos',
      margem: 'Ingreso, costo y margen de cada servicio vendido',
      quadro: 'Cuántas personas hay por departamento, función y situación',
      folha: 'Totales de la nómina de cada período',
      exportacoes: 'Archivos exportados de los informes, listos para descargar',
    },
    agenda: {
      recursos: 'Profesionales, salas y equipos que reciben citas',
      semana: 'Citas de la semana, por profesional o recurso',
      dia: 'Citas del día, hora a hora',
      mes: 'Vista del mes entero de citas',
    },
    estoque: {
      produtos: 'Administra el catálogo de productos',
      variacoes: 'Variantes de los productos (talla, color) y unidades de medida',
      depositos: 'Lugares donde se guarda el inventario',
      movimentacoes: 'Entradas, salidas y transferencias de inventario',
      reposicao: 'Productos bajo el mínimo y lo que hay que comprar',
      inventario: 'Conteos de inventario y ajustes de las diferencias',
      lotes: 'Lotes y fechas de vencimiento de los productos',
    },
    pipeline: {
      pipeline: 'Tus ventas en curso, etapa por etapa',
      equipes: 'Equipos de ventas y quién forma parte de cada uno',
      metas: 'Metas de ventas por período, equipo y vendedor',
      'motivos-perda': 'Motivos usados al marcar una oportunidad como perdida',
      atividades: 'Llamadas, reuniones y tareas ligadas a las oportunidades',
    },
    conversas: {
      whatsapp: 'Conversaciones con clientes por WhatsApp',
      instagram: 'Mensajes directos recibidos por Instagram',
      email: 'Bandeja de correo compartida con los clientes',
      portal: 'Mensajes enviados por los clientes en el portal',
      'respostas-rapidas': 'Textos listos para insertar en las conversaciones con un atajo',
      templates: 'Plantillas aprobadas por Meta para iniciar conversaciones en WhatsApp',
      filas: 'Colas de atención: grupos de personas que responden juntas',
      automacoes: 'Menú de entrada por canal y respuestas automáticas por palabra clave',
      site: 'Conversaciones abiertas por el chat de tus sitios',
      'chat-site': 'Chat para tus sitios: dominios, cola, apariencia y el código para pegar',
    },
    assinaturas: {
      contratos: 'Administra los contratos con clientes',
      planos: 'Catálogo de planes con precio, recurrencia e ítems para crear contratos',
      reajustes: 'Aprobación de los reajustes por índice en el aniversario de los contratos indefinidos',
      onboarding: 'Configuración del ciclo del cliente y modelo de onboarding que se abre al activar el contrato',
    },
    portal: {
      acessos: 'Qué clientes entran al portal y qué ve cada uno',
      configuracao: 'Cómo se ve el portal del cliente y qué ofrece',
    },
    pessoas: {
      funcionarios: 'Registro de los empleados de la empresa',
      departamentos: 'Departamentos y quién responde por cada uno',
      funcoes: 'Funciones y cargos usados en los contratos de trabajo',
      contratos: 'Contratos de trabajo, altas y bajas',
      documentos: 'Documentos confidenciales de los empleados',
      jornada: 'Jornadas y turnos de trabajo',
      habilidades: 'Habilidades y certificaciones de cada empleado',
    },
    folha: {
      beneficios: 'Beneficios ofrecidos y quién recibe cada uno',
      eventos: 'Ingresos y descuentos usados en el cálculo de la planilla',
      competencias: 'Planilla de cada mes, del cálculo al cierre',
      holerites: 'Recibos de sueldo generados para cada empleado',
      configuracao: 'Reglas y cuentas usadas en el cierre de la planilla',
    },
    compras: {
      compras: 'Compras de servicio que generan documentos por pagar',
      requisicoes: 'Pedidos internos de compra, para aprobación',
      cotacoes: 'Precios pedidos a los proveedores, lado a lado',
      pedidos: 'Órdenes de compra enviadas a los proveedores',
      recebimentos: 'Revisión de lo que llegó de las órdenes de compra',
      fornecedores: 'Proveedores a los que compra la empresa',
    },
    tarefas: {
      kanban: 'Tareas en columnas por estado, para arrastrar y soltar',
      lista: 'Todas las tareas en lista, con filtros',
      minhas: 'Las tareas asignadas a ti',
      painel: 'Indicadores de las tareas: plazos, atrasos y entregas',
      quadros: 'Tableros que organizan las tareas por proyecto o equipo',
      projetos: 'Proyectos con cliente, equipo, plazo, presupuesto y el tablero de tareas',
      marcos: 'Fechas importantes de los proyectos, de la más cercana a la más lejana',
    },
    equipe: {
      chat: 'Conversaciones y canales del equipo',
    },
    automacoes: {
      painel: 'Panel de los robots: estado, última y próxima ejecución, marcador del mes y cola de pendientes',
      feriados: 'Calendario de feriados que las ventanas de días hábiles de los robots saltan',
      fluxos: 'Automatizaciones de conversación de Instagram y WhatsApp, dibujadas en un lienzo',
      broadcast: 'Difusión de plantillas de WhatsApp a un público, con consentimiento, ritmo e informe',
    },
    treinamento: {
      cursos: 'Cursos y clases disponibles para el equipo',
      trilhas: 'Secuencias de cursos por función u objetivo',
      progresso: 'Quién hizo cada curso y el avance de cada persona',
    },
    ponto: {
      marcar: 'Registra tu jornada: hora del servidor, registros de hoy y el horario del día',
      marcacoes: 'Registros de jornada con el origen, la hora del dispositivo y la ubicación',
      espelho: 'Esperado por el horario contra lo trabajado, día a día, con extras, atrasos y faltas',
      ajustes: 'Registro olvidado o que no vale, con justificación y aprobación',
      banco: 'Saldo de horas de los meses cerrados y lo que vence pronto',
      fechamentos: 'Meses cerrados por empresa: bloquea la jornada y entrega el resultado a la nómina',
      fiscal: 'Control oficial (REP-P) y los archivos AFD y AEJ por período, firmados con el certificado',
      configuracao: 'Tolerancias, contratos que registran jornada y la política por empresa, departamento o empleado',
    },
    ausencias: {
      pedidos: 'Vacaciones, certificados, días libres y licencias solicitados por el equipo',
      aprovacoes: 'Solicitudes de ausencia esperando tu decisión',
      calendario: 'Quién está ausente o solicitó ausencia en cada mes',
      saldos: 'Días de derecho, usados y disponibles de cada empleado en el año',
      tipos: 'Tipos de ausencia y su regla de saldo, conteo y aprobación',
    },
    documentos: {
      arquivos: 'Archivos vinculados a clientes, proyectos y empleados, con sus versiones',
      contratos: 'Contratos generados de plantillas con los datos del registro',
      assinaturas: 'Documentos enviados para firmar, con el rastro de cada firma',
    },
    despesas: {
      despesas: 'Gastos del equipo con comprobante, categoría y centro de costo',
      aprovacoes: 'Gastos enviados esperando tu decisión',
      reembolsos: 'Gastos aprobados que se vuelven cuentas por pagar en Cuentas',
      centros: 'Aprobados y reembolsados en el período, por centro de costo',
    },
    integracoes: {
      conectores: 'Servicios externos conectados al sistema: WhatsApp, correo, cobros y agenda',
      webhooks: 'Avisos enviados a otros sistemas cuando algo pasa aquí',
      api: 'Claves de acceso a la API del sistema y el registro de llamadas',
      mcp: 'Servidor MCP para que agentes de IA usen el sistema',
      'conta-azul': 'Conta Azul hasta el corte: espejo, comparación con MalgoOS y archivo para importar',
    },
    admin: {
      painel: 'Salud del sistema: base de datos, colas, versión en línea y alertas',
      modulos: 'Instala y apaga módulos sin deploy',
      tenants: 'Tenants y workspaces atendidos por la plataforma',
      usuarios: 'Administra los usuarios y permisos del sistema',
      auditoria: 'Registro de quién hizo qué, y cuándo',
      saude: 'Versiones, servicios y tareas programadas del servidor',
      erros: 'Lo que la persona intentaba hacer cuando la pantalla falló, para corregir y rehacer',
      'historico-telas': 'Las pantallas antes y después de cada cambio, con imágenes del servidor',
      'tela-entrada': 'El logo y la imagen de fondo del inicio y del cierre de sesión, iguales para todos',
      'uso-ia': 'Tokens y costo de Claude Code por día, semana, mes y año',
    },
    configuracoes: {
      empresa: 'Datos de las empresas del workspace, usados en documentos y correos',
      aparencia: 'Personaliza el nombre, el logo, los colores y la fuente del sistema',
      modos: 'Cómo funciona cada módulo: simple o detallado',
      subsistemas: 'Dónde aparece cada página: por subsistema, en el workspace y en cada empresa',
      sequencias: 'Numeración automática de los documentos, sin huecos ni repeticiones',
      campos: 'Campos personalizados en los formularios y las tablas',
      'campos-telas': 'Qué campos aparecen y cuáles son obligatorios en cada pantalla de registro',
      visoes: 'Filtros, columnas y orden que guardaste en las tablas',
      modelos: 'Textos listos de correos, mensajes y documentos',
      estruturas: 'Etapas y funciones usadas por los otros módulos',
      crm: 'Atajo a la Configuración del CRM: embudos, motivos de pérdida, propuestas y workflows',
    },
  },
};
